export default __webpack_public_path__ + "static/project_mondelez-0897b972f4436123f743d640afd37f5e.svg";